import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const TermsRedirect = () => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate('/privacy#terms', { replace: true });
    }, [navigate]);

    return null;
};

export default TermsRedirect;
